/**
 * Stub for Document endpoints.
 */
export interface IDocumentEndpoints {
  getDocumentList: (filingId: string) => string;
  getDocketList: (caseId: string) => string;
  downloadDocument: (filingId: string, documentId: string, renderingName?: string) => string;
  getDocumentUri: () => string;
  postDocument: () => string;
  stampDocument: (filingId: string, documentId: string) => string;
}

/**
 * Document Endpoints
 * @param versionedUrl
 */
export const documentEndpoints = (versionedUrl: string): IDocumentEndpoints => {
const baseUrl = `${versionedUrl}api/Document`;

  return {
    getDocumentList: (filingId: string) => `${baseUrl}/${filingId}/documentList`,
    getDocketList: (caseId: string) => `${baseUrl}/${caseId}/docketList`,
    downloadDocument: (filingId: string, documentId: string, renderingName?: string) => !!renderingName ? `${baseUrl}/${filingId}/${documentId}/Download/${renderingName}` : `${baseUrl}/${filingId}/${documentId}/Download`,
    getDocumentUri: () => `${baseUrl}/uri`,
    postDocument: () => `${baseUrl}/import`,
    stampDocument: (filingId: string, documentId: string) => `${baseUrl}/${filingId}/${documentId}/Stamp`
  }
}
